module.exports = __webpack_public_path__ + "img/GreatNovels-lh.5ea82209.png";